import React, { useMemo } from 'react';
import Toast from './Toast';
import './Toast.css';

const ToastContainer = ({ notifications, removeNotification }) => {
  // Memoize notifications with stable onClose handlers
  const toasts = useMemo(() => {
    return notifications.map((notification) => ({
      ...notification,
      onClose: () => removeNotification(notification.id)
    }));
  }, [notifications, removeNotification]);

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          notification={toast}
          onClose={toast.onClose}
        />
      ))}
    </div>
  );
};

export default ToastContainer;

